<template>
<seccion-datos :titulo="cuentastitulo" tipo="warning" :="false" :botonGuardar="false">
            <div class="row">
                <div class="col-md-10">
                    <div class="input-group mb-3">
                      <input type="text" v-model="iban_cuenta" class="form-control form-control-sm" style="width:20px" maxlength="4">
                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                      <input type="text" v-model="iban2_cuenta" class="form-control form-control-sm" style="width:20px" maxlength="4">
                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                      <input type="text" v-model="entidad_cuenta" class="form-control form-control-sm" maxlength="4" >
                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                      <input type="text" v-model="oficina_cuenta" class="form-control form-control-sm" maxlength="4" >
                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                      <input type="text" v-model="control_cuenta" class="form-control form-control-sm" maxlength="4" >
                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                      <input type="text" v-model="numero_cuenta" class="form-control form-control-sm" maxlength="4" >
                    </div>
                </div>
                <div class="col-md-1">
                    <button class="btn btn-primary" @click="añadir(this.banco.id)">{{ $t('general.anadir') }}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-sm table-striped" v-if="cargando == false">
                        <tbody v-if="cuentas.length >1"> 
                            <tr v-for="cuenta of cuentas" :key="cuenta.id_cuenta"> 
                                 <td v-if="cuenta && cuenta.editar == true" class="col-md-8" >
                                    <div class="input-group mb-3">
                                      <input type="text" v-model="cuenta.iban_cuenta" class="form-control form-control-sm" style="width:20px" maxlength="4">
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuenta.iban2_cuenta" class="form-control form-control-sm" maxlength="4">
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuenta.entidad_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuenta.oficina_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuenta.control_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuenta.numero_cuenta" class="form-control form-control-sm" maxlength="4" >
                                    </div>
                                </td>
                                <td class="col-md-8" v-if="cuenta && cuenta.editar != true">
                                    {{cuenta.iban_cuenta}}-{{cuenta.iban2_cuenta}}-{{cuenta.entidad_cuenta}}-{{cuenta.oficina_cuenta}}-{{cuenta.control_cuenta}}-{{cuenta.numero_cuenta}}
                               </td>
                               <td v-if="cuentas" td class="col-md-2"><button v-if="cuenta.editar != true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="cuenta.editar = true">Editar</button>
                                </td>
                               <td class="col-md-2" >
                                    <button v-if="cuenta && cuenta.editar !=true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="eliminarCuenta(cuenta.id,cuenta.id_cuenta)">{{ $t('general.eliminar') }}</button><button v-if="cuenta.editar == true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="editarcuenta(cuenta);cuenta.editar = false">Guardar</button>
                               </td>                                                          
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td v-if="cuentas && cuentas.editar == true" class="col-md-8" >
                                    <div class="input-group mb-3">
                                      <input type="text" v-model="cuentas.iban_cuenta" class="form-control form-control-sm" style="width:20px" maxlength="4">
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuentas.iban2_cuenta" class="form-control form-control-sm" style="width:20px" maxlength="4">
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuentas.entidad_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuentas.oficina_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuentas.control_cuenta" class="form-control form-control-sm" maxlength="4" >
                                      <span class="input-group-text form-control-sm" id="basic-addon1">-</span>
                                      <input type="text" v-model="cuentas.numero_cuenta" class="form-control form-control-sm" maxlength="4" >
                                    </div>
                                </td>
                                <td v-if="cuentas && cuentas.editar != true" class="col-md-8">{{cuentas.iban_cuenta}}-{{cuentas.iban2_cuenta}}-{{cuentas.entidad_cuenta}}-{{cuentas.oficina_cuenta}}-{{cuentas.control_cuenta}}-{{cuentas.numero_cuenta}}              
                                </td>
                                <td v-if="cuentas" td class="col-md-2"><button v-if="cuentas.editar != true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="cuentas.editar = true">Editar</button><button v-if="cuentas.editar == true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="editarcuenta(cuentas);cuentas.editar = false">Guardar</button>
                                </td>
                                <td  td class="col-md-2"><button v-if="cuentas && cuentas.editar != true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="eliminarCuenta(cuentas.id,cuentas.id_cuenta)">{{ $t('general.eliminar') }}</button><button v-if="cuentas.editar == true" type="button" class="btn btn-block btn-outline-danger btn-xs" @click="cuentas.editar = false">Guardar</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['banco','id'],
    data() {
        return {
            cuentas: [],
            iban_cuenta: '',
            iban2_cuenta:'',
            entidad_cuenta: '',
            oficina_cuenta: '',
            control_cuenta: '',
            numero_cuenta: '',
            cuentastitulo: "Cuentas",
            cargando:false,
        }
    },
    methods: {
        async añadir(id) {
            /* post  modulos/pwgsapi/index.php/Bancos/:id/cuentas */
            const api = new PwgsApi;
            const subidadatos = { iban_cuenta: this.iban_cuenta,iban2_cuenta:this.iban2_cuenta, entidad_cuenta: this.entidad_cuenta, oficina_cuenta: this.oficina_cuenta, control_cuenta: this.control_cuenta, numero_cuenta: this.numero_cuenta };
            await api.post('bancos/' + id + '/cuentas', subidadatos);
                            this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });

            this.listadoCuentas(this.banco.id);
            this.iban_cuenta = '';
            this.iban2_cuenta = '';
            this.entidad_cuenta = '';
            this.oficina_cuenta = '';
            this.control_cuenta = '';
            this.numero_cuenta = '';
            this.$parent.$parent.obtenerCuentas(this.id);            
        },
        async editarcuenta(cuenta){
            //{{cuenta.iban_cuenta}}-{{cuenta.entidad_cuenta}}-{{cuenta.oficina_cuenta}}-{{cuenta.control_cuenta}}-{{cuenta.numero_cuenta}}
            const api = new PwgsApi;
            const subidadatos = { iban_cuenta: cuenta.iban_cuenta,iban2_cuenta: cuenta.iban2_cuenta, entidad_cuenta: cuenta.entidad_cuenta, oficina_cuenta: cuenta.oficina_cuenta, control_cuenta: cuenta.control_cuenta, numero_cuenta: cuenta.numero_cuenta };
            try{
            this.cargando = true;
            await api.post('bancos/' + this.banco.id + '/cuentas', subidadatos);
            this.eliminarCuenta(this.banco.id, cuenta.id_cuenta);
            this.listadoCuentas(this.banco.id);
            this.$parent.$parent.obtenerCuentas(this.id);
            setTimeout(() => {
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                this.cargando = false;
            }, 1000);
            }
            catch(error){
                console.error('Error al editar la cuenta:', error);
            }

        },
        async eliminarCuenta(idbanco, idcuenta) {
            /* delete  modulos/pwgsapi/index.php/Bancos/:id/cuentas/:id_cuenta */
            const api = new PwgsApi;
            await api.delete('bancos/' + idbanco + '/cuentas/' + idcuenta);
            this.listadoCuentas(this.banco.id);
            this.$parent.$parent.obtenerCuentas(this.id);
        },
        async listadoCuentas(id) {
            /* get  modulos/pwgsapi/index.php/bancos/:id/cuentas */
            const api = new PwgsApi;
            const datos = await api.get('bancos/' + id + '/cuentas');
            this.cuentas = datos.datos;
            this.cuentastitulo = this.$t("general.cuentas");
        },
      },
    watch: {
        banco() {
            this.listadoCuentas(this.banco.id);
            this.$parent.$parent.obtenerCuentas(this.id);
        }
    }
}
</script>